export const NETWORK = {
  TWITTER: 'twitter',
  LINKED_IN: 'linkedin',
  TELEGRAM: 'telegram',
  FACEBOOK: 'facebook',
  WHATS_APP: 'whatsapp',
  EMAIL: 'email',
  REDDIT: 'reddit'
}
